import { useContext } from "react";
import { CreateActionContext } from "./CreateActionContext";
import { ChangeDectionContext } from "@beeldit/core/context/ChangeDectionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(CreateActionContext);
  const { setChanged } = useContext(ChangeDectionContext);
  return (initializeData: any = {}) => {
    // Aseguramos que en creación el elemento tenga un status por defecto (evita undefined)
    const initial = {
      status: initializeData.status !== undefined ? initializeData.status : 0,
      ...initializeData,
    };
    setElement(initial);
    setShowModal(true);
    setTimeout(() => {
      setChanged(false, initializeData);
    }, 3000);
  };
}

export default useInitialize;
